module.exports = __webpack_public_path__ + "static/media/25487599_1703509856390865_5962340643052516311_o.0a4189c3.jpg";